"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _components = require("./components");
var _useManagerAppointmentCubby = require("./useManagerAppointmentCubby");
var _components2 = require("../../components");
var _excluded = ["visible", "onCancel", "onSuccess", "clinician", "patient", "appointment"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var ManagerAppointmentCubbyContent = function ManagerAppointmentCubbyContent(_ref) {
  var showOnlyManagedAvailability = _ref.showOnlyManagedAvailability;
  var _useManagerAppointmen = (0, _useManagerAppointmentCubby.useManagerAppointmentCubby)(),
    stage = _useManagerAppointmen.stage;
  switch (stage) {
    case _useManagerAppointmentCubby.NewAppointmentStage.SelectParticipants:
      {
        return /*#__PURE__*/_react.default.createElement(_components.SelectParticipantsScreen, null);
      }
    case _useManagerAppointmentCubby.NewAppointmentStage.SelectAppointmentType:
      {
        return /*#__PURE__*/_react.default.createElement(_components.SelectAppointmentTypeScreen, null);
      }
    case _useManagerAppointmentCubby.NewAppointmentStage.SelectSingleAppointment:
      {
        return /*#__PURE__*/_react.default.createElement(_components.SelectSingleAppointmentScreen, {
          showOnlyManagedAvailability: showOnlyManagedAvailability
        });
      }
    case _useManagerAppointmentCubby.NewAppointmentStage.SelectNewSingleAppointment:
      {
        return /*#__PURE__*/_react.default.createElement(_components.SelectNewSingleAppointmentScreen, {
          showOnlyManagedAvailability: showOnlyManagedAvailability
        });
      }
    case _useManagerAppointmentCubby.NewAppointmentStage.SelectRecurringAppointment:
      {
        return /*#__PURE__*/_react.default.createElement(_components.SelectRecurringAppointmentScreen, null);
      }
    case _useManagerAppointmentCubby.NewAppointmentStage.SelectNewRecurringAppointment:
      {
        return /*#__PURE__*/_react.default.createElement(_components.SelectNewRecurringAppointmentScreen, null);
      }
    case _useManagerAppointmentCubby.NewAppointmentStage.ManageRecurring:
      {
        return /*#__PURE__*/_react.default.createElement(_components.ManageRecurringScreen, null);
      }
    default:
      {
        return null;
      }
  }
};
function ManagerAppointmentCubby(_ref2) {
  var visible = _ref2.visible,
    onCancel = _ref2.onCancel,
    onSuccess = _ref2.onSuccess,
    clinician = _ref2.clinician,
    patient = _ref2.patient,
    appointment = _ref2.appointment,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/_react.default.createElement(_components2.Cubby, {
    visible: visible,
    overlayStyles: "fixed top-0 right-0 w-screen h-screen z-cubby-overlay",
    cubbyStyles: "fixed bottom-0 right-0 h-[calc(100vh-theme(spacing.app-header-height))] w-[476px] pt-[36px] pb-[24px] z-cubby",
    onClose: onCancel
  }, visible && /*#__PURE__*/_react.default.createElement(_useManagerAppointmentCubby.ManagerAppointmentCubbyContextProvider, {
    targetClinician: clinician,
    targetPatient: patient,
    appointment: appointment,
    onCancel: onCancel,
    onSuccess: onSuccess
  }, /*#__PURE__*/_react.default.createElement(ManagerAppointmentCubbyContent, props)));
}
var _default = ManagerAppointmentCubby;
exports.default = _default;